import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../assets/logo.jpg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const apiBase = process.env.REACT_APP_API;

const Register = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    password: "",
    confirm_password: "",
    NIC: "",
    email: "",
    address: "",
    city: "",
    district: "",
    
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const {
      first_name,
      last_name,
      phone_number,
      NIC,
      password,
      confirm_password,
      email,
      address,
      district,
      city,
    } = formData;

    const sanitizedPhoneNumber = phone_number.replace(/\s+/g, "");

    try {
      const response = await axios.post(`${apiBase}/auth/register`, {
        first_name,
        last_name,
        phone_number : sanitizedPhoneNumber,
        NIC,
        password,
        confirm_password,
        email,
        address,
        district,
        city,
      });
      // localStorage.setItem("token", response.data.token);

      // alert("User registered successfully!");
      toast.success("User registered successfully!"); //only for testing
      toast.success("Now you can login to the system."); //only for testing
      navigate("/login"); // Redirect to  page after successful registration
    } catch (err) {
      let error_messege = err.response.data.error.message;
      console.error(error_messege);
      toast.error(error_messege); //
    } finally {
      setIsLoading(false);
    }
  };
  console.log(formData);
  return (
    <section className="signupContainer bg-white flex flex-col items-center justify-center m-8  mt-24 sm:mt-36 ">
      <div className="flex flex-col justify-center items-center ">
        <img src={Logo} alt="logo" className="size-28 rounded-full" />
        <h1 className=" text-center text-myBlue font-semibold  text-4xl mt-4 mb-1 ">
          Welcome to A/L Guidance
        </h1>
        <p className=" text-center w-5/6 font-light mb-4">
          start your journey with our expert tutors and advanced learning
          resources. Let’s make bio learning both effective and enjoyable!
        </p>
      </div>
      <div className="flex  flex-col justify-center items-center w-full max-w-md bg-white rounded-2xl shadow-lg p-6 space-y-4 md:space-y-6 border">
        <h2 className="text-xl font-bold leading-tight text-myBlue">
          Register Now
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6 w-full">
          <div className="formGroup">
            <label
              htmlFor="first_name"
              className="block mb-2 text-sm font-medium text-myBlack"
            >
              First Name:
            </label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              placeholder="Enter your first name"
              value={formData.first_name}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div className="formGroup">
            <label
              htmlFor="last_name"
              className="block mb-2 text-sm font-medium text-myBlack"
            >
              Last Name:
            </label>
            <input
              type="text"
              id="last_name"
              name="last_name"
              placeholder="Enter your last name"
              value={formData.last_name}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div className="formGroup">
            <label
              htmlFor="phone_number"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Phone number:
            </label>
            <p className="text-gray-900 opacity-40">
              (The contact number you provided will not be changed. Please
              ensure a valid contact number is registered, as it will be linked
              to the sessions)
            </p>
            <input
              type="text"
              id="phone_number"
              name="phone_number"
              placeholder="Enter your phone number"
              value={formData.phone_number}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div className="formGroup">
            <label
              htmlFor="NIC"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              NIC:
            </label>
            <input
              type="text"
              id="NIC"
              name="NIC"
              placeholder="NIC"
              value={formData.NIC}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div className="formGroup">
            <label
              htmlFor="Email"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Email:
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="email"
              value={formData.email}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div className="formGroup">
            <label
              htmlFor="address"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              address:
            </label>
            <input
              type="text"
              id="address"
              name="address"
              placeholder="address"
              value={formData.address}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div className="formGroup">
            <label
              htmlFor="district"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              District:
            </label>
            <select
              name="district"
              id="district"
              value={formData.district}
              onChange={handleChange}
              className="block w-full p-2 border border-gray-300 rounded-md"
            >
              <option value="" disabled>
                Select district
              </option>
              <option value="Colombo">Colombo</option>
              <option value="Gampaha">Gampaha</option>
              <option value="Kalutara">Kalutara</option>
              <option value="Kandy">Kandy</option>
              <option value="Matale">Matale</option>
              <option value="Nuwara Eliya">Nuwara Eliya</option>
              <option value="Galle">Galle</option>
              <option value="Matara">Matara</option>
              <option value="Hambantota">Hambantota</option>
              <option value="Jaffna">Jaffna</option>
              <option value="Kilinochchi">Kilinochchi</option>
              <option value="Mannar">Mannar</option>
              <option value="Vavuniya">Vavuniya</option>
              <option value="Mullaitivu">Mullaitivu</option>
              <option value="Batticaloa">Batticaloa</option>
              <option value="Ampara">Ampara</option>
              <option value="Trincomalee">Trincomalee</option>
              <option value="Kurunegala">Kurunegala</option>
              <option value="Puttalam">Puttalam</option>
              <option value="Anuradhapura">Anuradhapura</option>
              <option value="Polonnaruwa">Polonnaruwa</option>
              <option value="Badulla">Badulla</option>
              <option value="Moneragala">Moneragala</option>
              <option value="Ratnapura">Ratnapura</option>
              <option value="Kegalle">Kegalle</option>
            </select>
          </div>

          <div className="formGroup">
            <label
              htmlFor="city"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              city:
            </label>
            <input
              type="text"
              id="city"
              name="city"
              placeholder="city"
              value={formData.city}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div className="formGroup">
            <label
              htmlFor="password"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Password:
            </label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div className="formGroup">
            <label
              htmlFor="confirm_password"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Confirm password:
            </label>
            <input
              type="password"
              id="confirm_password"
              name="confirm_password"
              placeholder="Confirm password"
              value={formData.confirm_password}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-1 focus:outline-none focus:ring-myBlue block w-full p-2.5"
            />
          </div>
          <div className="flex flex-col items-center space-y-5">
            {
              !isLoading ? (
                <button
                type="submit"
                className="signupButton mt-4 text-white bg-myBlue hover:bg-myPurple focus:ring-1 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-16 py-2.5 text-center flex justify-center items-center"
              >
                Register
              </button>
              ) :
              (
                <button 
                className="signupButton flex items-center justify-center mt-4 text-white bg-myBlue hover:bg-myPurple focus:ring-1 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-16 py-2.5 text-center flex justify-center items-center"

>
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                  ></path>
                </svg>
                
              </button>
              )
            }


            <div className="login flex items-center justify-between">
              <p className="text-sm font-medium text-gray-500">
                Already have an account?{" "}
                <Link to="/login" className="text-myBlue hover:underline">
                  Login
                </Link>
              </p>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Register;
